<template>
  <div class="container">
    <h1>Course Scheduler</h1>
    <p class="error" v-if="error">{{ error }}</p>
    <div class="course-container">
      <div class="course-add">
        <div>
          <label for="username"> Username</label>
          <input type="text" id="username" v-model="username" placeholder="enter username" disabled required>
        </div>
        <div>
          <label for="email"> Email</label>
          <input type="text" id="email" v-model="email" placeholder="enter email" disabled>
        </div>
        <label for="studentId"> Student Id</label>
        <input type="text" id="studentId" v-model="studentId" placeholder="enter student id" disabled required>
        <div>
          <label for="subjects"> Select Subject</label>
          <select id="subjects" v-model="subject" required>
            <option disabled value="">Please select one</option>
            <option v-for="(subject, index) in subjects" :item="subject" :index="index" :key="subject.id" v-bind:value="subject.tid">{{subject.subject}}</option>
          </select>
        </div>
        <div v-if="topics.length > 0">
          <label for="topics"> Select Topic</label>
          <select  id="topics" v-model="topic" required>
            <option disabled value="">Please select one</option>
            <option v-for="(topic, index) in topics" :item="topic" :index="index" :key="topic.id" v-bind:value="topic.tid">{{topic.name}}</option>
          </select>
        </div>
        <div v-if="sections.length > 0">
          <label for="sections"> Select Time</label>
          <select  id="sections" v-model="courseUUID" required>
            <option disabled value="">Please select one</option>
            <option v-for="(section, index) in sections" :item="section" :index="index" :key="section.id" v-bind:value="[section.uuid, section.field_course_time]">{{section.field_course_time}}</option>
          </select>
        </div>
        <button @click="insertCourse">Submit</button>
      </div>
      <hr>
      <div class="course-schedule">
        <h2>User Information</h2>
        <p class="username">{{ username }}</p>
        <p class="username">{{ email }}</p>
        <p class="username">{{ studentId }}</p>
        <h2>Course Schedule</h2>
        <table>
        <tr class="course-section" v-for="(course, index) in courses" :item="course" :index="index" :key="course.nid">
          <td class="title">{{ course.name_1 }}</td>
          <td class="title">{{ course.name }}</td>
          <td class="time">{{ course.field_course_time }}</td>
        </tr>
        <table>
      </div>
    </div>
  </div>
</template>

<script>
import PostService from '../PostService'
export default {
  name: 'courseComponent',
  data() {
    return {
      user: {},
      courses:[],
      subjects:[],
      topics:[],
      sections:[],
      unavail:[],
      subject: '',
      topic: '',
      courseUUID: '',
      username: '',
      email: '',
      studentId: '',
      userUUID: '',
      userId: localStorage.getItem("currentUser"),
      error: '',
    }
  },
  async created(){
    try {
      this.user = await PostService.getUser(this.userId);
      this.userUUID = this.user[0].uuid;
      this.username = this.user[0].name;
      this.email = this.user[0].mail;
      this.studentId = this.user[0].field_student_id;
      this.subjects = await PostService.getSubjects();
      this.courses = await PostService.getCourses(this.userId);
      const unavailable = () => {
        for(let i = 0; i < this.courses.length; i++){
          let time = this.courses[i].field_course_time;
          let parsedTime = Date.parse(`01 Jan 1970 ${time}:00 GMT`);
          this.unavail.push(parsedTime);
        }
      }
      unavailable();
    } catch(err) {
      this.error = err.message;
    }
  },
  methods: {
    async insertCourse() {
      try {
        let startTime = this.courseUUID[1];
        let parsedStartTime = Date.parse(`01 Jan 1970 ${startTime}:00 GMT`);
        this.unavail.forEach(time => {
          if (parsedStartTime >= time && parsedStartTime < time + 3600000 ) { 
            throw new Error('Time conflict: Please select a different course.')
          }
        });
        await PostService.insertCourse(this.userUUID, this.courseUUID[0]);
        this.courses = await PostService.getCourses(this.studentId);
        this.subjects = [];
        this.topics = [];
        this.sections = [];
      } catch(err) {
        this.error = err.message;
      }
    }
  },
  watch: {
    subject: async function(){
      try {
        this.topics = await PostService.getTopics(this.subject);
      } catch(err) {
        this.error = err.message;
      }
    },
    topic: async function(){
      try {
        this.sections = await PostService.getSections(this.topic);
      } catch(err) {
        this.error = err.message;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .course-container {
    display: flex;
    flex-wrap: wrap;
  }
  .course-schedule {
    width: 100%;
  }
  .course-add {
    width: 100%;
  }
  @media (min-width: 758px){
    .course-schedule {
      width: 49%;
    }
    .course-add {
      width: 49%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Admin.vue